{
  "eyebrow": "Hesabınızı oluşturun",
  "title": "Şirketinizle ilgili birkaç bilgi.",
  "sub": "Ana yönetici siz olacaksınız. Kurulumdan sonra daha fazla yönetici davet edebilirsiniz.",
  "company": "Şirket",
  "companyName": "Şirket adı",
  "companyVat": "Vergi numarası",
  "companyVatBssHint": "Belçika Sosyal Güvenlik (DIMONA) bildirimleri için gereklidir.",
  "companyCountry": "Ülke",
  "admin": "Ana yönetici",
  "adminFirst": "Ad",
  "adminLast": "Soyad",
  "adminEmail": "İş e-postası",
  "adminPhone": "Telefon",
  "adminPw": "Parola",
  "adminPwHint": "En az 10 karakter, bir rakam.",
  "adminPwShow": "Parolayı göster",
  "adminPwHide": "Parolayı gizle",
  "terms": {
    "pre": "Kabul ediyorum:",
    "t": "Hizmet Şartları",
    "and": "ve",
    "p": "Gizlilik Politikası"
  },
  "cta": "Hesap oluştur ve devam et",
  "errors": {
    "required": "Zorunlu",
    "tooShort": "Çok kısa",
    "invalidEmail": "Geçerli bir e-posta girin",
    "invalidVat": "Geçerli bir vergi numarası girin",
    "invalidBelgianVat": "Geçerli bir Belçika vergi numarası girin (örn. BE0123456789).",
    "invalidPhone": "Geçerli bir telefon numarası girin",
    "passwordWeak": "En az 12 karakter ve bir rakam",
    "termsRequired": "Şartları kabul etmelisiniz",
    "emailExists": "Bu e-posta zaten kullanılıyor",
    "vatRequiredForBss": "Belçika Sosyal Güvenlik için vergi numarası gereklidir",
    "network": "Ağ veya sunucu hatası. Tekrar deneyin.",
    "throttled": "Çok fazla deneme. {{minutes}} dk. sonra tekrar deneyin."
  },
  "verify": {
    "awaitingTitle": "Gelen kutunuzu kontrol edin",
    "awaitingSub": "{{email}} adresine bir doğrulama bağlantısı gönderdik. Hesabınızı etkinleştirmek ve ücretsiz denemenizi başlatmak için tıklayın.",
    "awaitingSubNoEmail": "Size bir doğrulama bağlantısı gönderdik. Hesabınızı etkinleştirmek ve ücretsiz denemenizi başlatmak için tıklayın.",
    "resend": "E-postayı tekrar gönder",
    "resendCooldown": "{{seconds}}sn sonra tekrar gönder",
    "verifyingTitle": "Doğrulanıyor…",
    "successTitle": "30 günlük ücretsiz denemeniz başladı!",
    "successSub": "Kredi kartı gerekmez. Done-it'i kullanmaya başlamak için kontrol panelinize giriş yapın.",
    "errorTitle": "Bu bağlantıyı doğrulayamadık",
    "errorSub": "Bağlantı süresi dolmuş olabilir. Hesap bilgilerinden yeniden başlayın.",
    "errorCta": "Hesaba dön",
    "interstitial": "E-posta doğrulama",
    "subscribedTitle": "Hesabınız hazır",
    "subscribedSub": "Ödeme zaten tamamlandı. Done-it kullanmaya başlamak için kontrol panelinize giriş yapın.",
    "subscribedCta": "Kontrol paneline giriş yap",
    "successCta": "Kontrol panelini aç",
    "successNote": "Deneme süreniz boyunca birkaç yararlı e-posta ve süre sonuna doğru abone olma bağlantısı alırsınız.",
    "awaitingSubFree": "{{email}} adresine bir doğrulama bağlantısı gönderdik. Ücretsiz hesabınızı etkinleştirmek için tıklayın — Time Zero sonsuza dek ücretsizdir, kredi kartı gerekmez.",
    "awaitingSubFreeNoEmail": "Size bir doğrulama bağlantısı gönderdik. Ücretsiz hesabınızı etkinleştirmek için tıklayın — Time Zero sonsuza dek ücretsizdir, kredi kartı gerekmez.",
    "successTitleFree": "Ücretsiz hesabınız hazır!",
    "successNoteFree": "Time Zero, sınırları dahilinde sonsuza dek ücretsizdir. Sınırsız kullanım için istediğiniz zaman yükseltin."
  }
}
